import React, { useEffect, useState } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";

import Header from "../Global/Header";
import Itemeduc from "./Itemeducation";
import { withRouter } from "react-router";

const Mycourses = (props) => {
  const [state, setState] = useState({
    data: [],
    loader: true,
    tutorialCount: 0,
    locked: false,
  });

  useEffect(() => {
    localStorage.setItem("QuizResault", {});

    base_url
      .get(`course/${props.match.params.id}`,)
      .then((response) => {
        console.log(response.data, "course");
        const tutorialCount = response.data.tutorials;
        let readedCount = 0;
        tutorialCount.map((info) => (readedCount += info.read ? 1 : 0));
        setState({
          ...state,
          data: response.data,
          loader: false,
          tutorialCount: response.data.tutorials.length,
          locked: readedCount == response.data.tutorials.length,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  const handleOnclick = (id) => {
    props.history.push(`/Education/course-content/${id}`);
  };

  const startQuiz = (e) => {
    if (state.locked) {
      // localStorage.setItem('QuizBackUrl', props.match.url);
      props.history.push(
        `/Education/Quiz/${state.data.tutorials[0].pivot.course_id}/1`
      );
    } else {
      e.preventDefault();
    }
  };
  console.log(state);

  return (
    <div className="instructpg my-courses">
      <Loader active={state.loader} />
      <Header innerPage={true} title={"کرس درسی / طراحی"} />

      <div className={`inner-mycours ${state.loader ? "active" : ""}`}>
        <div className="progresbar">
          <span>{state.data.length !== 0 ? state.data.progress : ""}%</span>
          <LinearProgress
            variant="determinate"
            value={state.data.length !== 0 ? state.data.progress : ""}
          />
        </div>
        <div className="list-item">
          {state.data.length !== 0
            ? state.data.tutorials.map((info) => (
                <Itemeduc
                  title={info.title}
                  type="course"
                  image={info.image}
                  read={info.read}
                  handleClick={() => handleOnclick(info.id)}
                />
              ))
            : null}
        </div>
      </div>

      {/* <div className={`btn-base btn-black btn-sircle ${state.locked ? 'active' : ''}`}>
                <Button
                    variant="contained"
                    onClick={startQuiz}>
                    شروع آزمون
                </Button>
            </div> */}
    </div>
  );
};

export default withRouter(Mycourses);
